import { render } from "./SalonEntry.vue?vue&type=template&id=e3c55b3c&scoped=true"
import script from "./SalonEntry.vue?vue&type=script&lang=js"
export * from "./SalonEntry.vue?vue&type=script&lang=js"

import "./SalonEntry.vue?vue&type=style&index=0&id=e3c55b3c&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c55b3c"]])

export default __exports__